import { mapState, mapMutations, mapActions } from 'vuex'
import AppHeader from '@/components/header/header.vue'
import FixFluidColGrid from '@/components/fix-fluid-col-grid/fix-fluid-col-grid.vue'
import AppMenu from '@/components/menu/menu.vue'
import ErrorModal from '@/components/modals/error-modal/error-modal.vue'
import CopyNotification from '@/components/copy-notification/copy-notification.vue'
import Loader from '@/components/loader/loader.vue'
import { sharedPages, managersPages, topManagersPages, superUsers } from '@/const'
import LostConnectionsModal from '@/components/modals/lost-connections-modal/lost-conntections-modal.vue'

export default {
  name: 'App',
  components: {
    LostConnectionsModal,
    AppHeader,
    AppMenu,
    FixFluidColGrid,
    ErrorModal,
    CopyNotification,
    Loader
  },
  data() {
    return {
      wsConnection: null,
      sharedTimeTimeout: null,
      routerKey: null
    }
  },
  computed: {
    ...mapState({
      modalsCount: state => state.modalsCount,
      notUserSelect: state => state.notUserSelect,
      user: state => state.users.user,
      pageLoading: state => state.pageLoader.loading,
      cities: state => state.manufactures.cities,
      manufactures: state => state.manufactures.manufactures,
      selectedManufacture: state => state.manufactures.selectedManufacture
    })
  },
  async mounted() {
    this.$bus.$on('error-403', this.onError403)
    this.recursiveSetSharedTime()

    this.setLoading(true)

    const token = localStorage.getItem('token')
    try {
      if (token) {
        if (this.$route.name === 'auth') {
          await this.logout()
        } else {
          await Promise.all([
            this.fetchProfile(),
            this.fetchAutoRouteTaskStatus() // Новый запрос
          ])
        }
      } else {
        await this.logout()
      }
    } finally {
      this.setLoading(false)
      this.startInactivityTimer()
    }
  },
  beforeDestroy() {
    this.$bus.$off('error-403', this.onError403)
    clearTimeout(this.sharedTimeTimeout)
    this.sharedTimeTimeout = null
    this.stopInactivityTimer()
  },

  methods: {
    ...mapActions({
      fetchProfile: 'users/fetchProfile',
      logout: 'users/logout',
      getWorkshopsInfo: 'orders/getWorkshopsInfo',
      getCities: 'manufactures/getCities',
      getAllSharedData: 'sharedData/getAllSharedData',
      setSelectedCityAction: 'manufactures/setSelectedCity',

      setAcceptConnection: 'collectOrders/setAcceptConnection',
      setRemakeConnection: 'collectOrders/setRemakeConnection',
      fetchAutoRouteTaskStatus: 'logistics/fetchAutoRouteTaskStatus'
    }),
    ...mapMutations({
      setSharedTime: 'sharedTime/SET_TIME',
      setSelectedManufacture: 'manufactures/SET_SELECTED_MANUFACTURE',
      setLoading: 'pageLoader/SET_LOADING',
      removeUserManufacture: 'users/REMOVE_USER_MANUFACTURE'
    }),

    addEventListeners() {
      document.addEventListener('keydown', this.resetInactivityTimer)
      document.addEventListener('mousemove', this.resetInactivityTimer)
      document.addEventListener('click', this.resetInactivityTimer)
      window.addEventListener('scroll', this.resetInactivityTimer)
      window.addEventListener('resize', this.resetInactivityTimer)
    },

    removeEventListeners() {
      document.removeEventListener('keydown', this.resetInactivityTimer)
      document.removeEventListener('mousemove', this.resetInactivityTimer)
      document.removeEventListener('click', this.resetInactivityTimer)
      window.removeEventListener('scroll', this.resetInactivityTimer)
      window.removeEventListener('resize', this.resetInactivityTimer)
    },

    startInactivityTimer() {
      this.addEventListeners()
      this.inactivityTimer = window.setTimeout(() => {
        this.$refs['lost-connections-modal'].show()
      }, 300000) // 5 минут
    },

    resetInactivityTimer() {
      this.stopInactivityTimer()
      this.startInactivityTimer()
    },

    stopInactivityTimer() {
      if (this.inactivityTimer !== null) {
        clearTimeout(this.inactivityTimer)
        this.inactivityTimer = null
        this.removeEventListeners()
      }
    },

    recursiveSetSharedTime() {
      this.sharedTimeTimeout = setTimeout(() => {
        this.setSharedTime(new Date())
        this.recursiveSetSharedTime()
      }, 1000)
    },
    async setCitiesData() {
      try {
        this.setLoading(true)
        /**
         * После авторизации выбор прозводств и городов только для superUsers
         */
        if (superUsers.indexOf(this.user.role) !== -1) {
          await this.getCities()
          if (!this.cities.length) {
            await this.logout()
            return
          }
          const selectedCity = this.cities.find(c => c.city_id === this.selectedManufacture.city_id)
          this.setSelectedCityAction(selectedCity)
        }

        if (this.$route.name === 'auth') {
          this.$router.replace({ name: 'main' })
        }
      } finally {
        this.setLoading(false)
      }
    },
    async setManufactureBindedData() {
      this.setLoading(true)
      try {
        await Promise.all([this.getWorkshopsInfo(), this.setRemakeConnection()])
      } finally {
        this.setLoading(false)
      }
    },
    async onError403() {
      this.setSelectedManufacture(null)
      this.removeUserManufacture()
      await this.fetchProfile()
    }
  },
  watch: {
    /**
     * Даже если есть токен, изначально пользователя нет
     */
    user() {
      if (this.wsConnection) {
        this.wsConnection.close()
      }
      if (this.user) {
        let userManufacture = null
        if (this.user.manufacture) {
          userManufacture = this.user.manufacture
        } else {
          let storageManufacture = localStorage.getItem('selectedManufacture')
          if (storageManufacture) {
            userManufacture = JSON.parse(storageManufacture)
          }
        }
        this.getAllSharedData()

        /** */

        if (userManufacture) {
          this.setSelectedManufacture(userManufacture)
          this.setCitiesData()
        } else if (sharedPages.indexOf(this.$route.name) === -1) {
          this.$router.push({
            name: 'welcome-screen'
          })
        }
      }
    },
    selectedManufacture: {
      immediate: true,
      handler() {
        if (this.user && this.selectedManufacture) {
          /**
           * Если у пользователя нет manufacture,
           * то запросы из setManufactureBindedData
           * произойдут в welcome-screen
           */
          if (this.$route.name !== 'welcome-screen') {
            this.setManufactureBindedData()
          }
        }
        if (this.selectedManufacture) {
          /**
           * только в случае если this.selectedManufacture !== null
           * и это функциональная страница, мы перерисовываем страницу
           */
          const notDependPages = [...sharedPages, ...managersPages, ...topManagersPages]
          if (!notDependPages.includes(this.$route.name)) {
            this.routerKey = this.selectedManufacture.id
          }
        }
      }
    }
  }
}
